import React from 'react';
import { appVersion } from '../../config/AppVersion';

const Footer = () => {
  return (
    // <footer
    //   className="footer text-white bg-primary fw-bold py-2 small shadow-sm mt-auto"
    //   style={{
    //     background:
    //       'linear-gradient(45deg, rgb(29, 100, 216) 0%, rgba(17, 29, 65, 1) 100%)',
    //     width: '100%',
    //     flexShrink: 0,
    //   }}
    // >
    <footer 
      className="footer text-white bg-success fw-bold py-1 small w-100 shadow-sm"
      style={{
        background: 'linear-gradient(45deg, rgb(29, 100, 216) 0%, rgba(17, 29, 65, 1) 100%)',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1045,
      }}
    >
      <div className="container d-flex justify-content-between align-items-center small">
        <p className="mb-0 flex-grow-1 text-center">
          © {new Date().getFullYear()} - I & J Serviços de Consultoria em TI -
          Todos os direitos reservados.
        </p>
        <p className="mb-0 ms-3">{appVersion}</p>
      </div>
    </footer>
  );
};

export default Footer;
